import React, { useRef, useCallback, useEffect, useState, memo, } from 'react';
import styled from '../../styled';
import { Chevron } from '../icons/outline';
const PanelContainer = styled.div `
  width: 100%;
  ${({ noBorderBottom, theme }) => !noBorderBottom && `border-bottom: 1px solid ${theme.colors.SKY_DEFAULT}`};
`;
const PanelHeader = styled.div `
  display: flex;
  height: ${({ headerHeight }) => headerHeight || `3.5rem`};
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  ${({ noPadding }) => !noPadding && `padding: 0 1.8125rem 0 1rem`};
`;
const PanelContent = styled.div `
  overflow: hidden;
  position: relative;
  height: ${({ isActive, height }) => (isActive ? `${height || 0}px` : 0)};
  transition: all
    ${({ isActive }) => isActive
    ? `0.05s cubic-bezier(.08,.82,.17,1)`
    : `0.1s cubic-bezier(.6,.04,.98,.34)`};
`;
const Animation = styled.div `
  transform: translateY(-100%);
  ${({ isActive }) => isActive && 'transform: translateY(0%)'};
  transition: all
    ${({ isActive }) => isActive
    ? `0.2s cubic-bezier(.08,.82,.17,1)`
    : `0.3s cubic-bezier(.6,.04,.98,.34)`};
  ${({ noPadding }) => !noPadding && `padding: 0 1.8125rem 1rem 1rem`};
`;
const IconContainer = styled.div `
  display: flex;
  align-items: center;
  height: 100%;
  transition: all 0.2s linear;
  ${({ isActive }) => !isActive && 'transform: rotate(180deg)'};
`;
const Panel = ({ noBorderBottom, noPadding, header, headerHeight, panelKey, isActive = false, expandIcon, disabled, children, onClickPanel, }) => {
    const contentRef = useRef(null);
    const [contentHeight, setContentHeight] = useState(0);
    const clickHandler = useCallback((e) => {
        if (onClickPanel && !disabled)
            onClickPanel(e, panelKey);
    }, [onClickPanel, panelKey, disabled]);
    useEffect(() => {
        var _a;
        setContentHeight(((_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) || 0);
    }, [setContentHeight]);
    return (React.createElement(PanelContainer, { noBorderBottom: noBorderBottom },
        React.createElement(PanelHeader, { headerHeight: headerHeight, noPadding: noPadding, onClick: clickHandler },
            header,
            React.createElement(IconContainer, { isActive: isActive }, expandIcon || React.createElement(Chevron, { size: "MEDIUM", color: "INK_LIGHT" }))),
        React.createElement(PanelContent, { isActive: isActive, height: contentHeight },
            React.createElement(Animation, { ref: contentRef, isActive: isActive, noPadding: noPadding }, children))));
};
export default memo(Panel);
//# sourceMappingURL=Panel.js.map